import { parentPageTypeMapping } from '@databases/collab/convert/to-collab';
import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setPageLocation: YJSChangeHandler<DatabaseChangeType.SET_PAGE_LOCATION> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.parentPageType = parentPageTypeMapping[change.newParentPageType];
  });
};
